import React from "react";
import { Octagon, ArrowRight } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const processSteps = [{
  id: 1,
  title: "Comprehensive Inspection",
  description: "We thoroughly inspect your property, paying special attention to foundation cracks common in older Florida homes where pests often enter."
}, {
  id: 2,
  title: "Targeted Treatment",
  description: "Using advanced methods suited for our local sandy soil, we apply treatments that effectively eliminate pests at their source."
}, {
  id: 3,
  title: "Detailed Follow-up",
  description: "We return to ensure the treatment was successful, adapting to the humid Southwest Florida climate that pests love."
}, {
  id: 4,
  title: "Year-Round Prevention",
  description: "Ongoing protection plans designed to keep your home safe from future infestations in North Fort Myers and beyond."
}];
export default function PestControlProcessTimeline() {
  return <section id="pestcontrolprocesstimeline" className="bg-background text-foreground py-16 md:py-24 overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="font-default text-3xl md:text-5xl font-bold mb-4 text-foreground">
            Our Proven 4-Step Process
          </h2>
          <p className="font-serif text-lg text-muted-foreground">
            Protecting Peace River Pest Control customers with reliable, local expertise tailored to Southwest Florida's unique environment.
          </p>
        </div>

        <div className="relative max-w-6xl mx-auto">
          {}
          <div className="hidden md:block absolute top-6 left-[12.5%] right-[12.5%] h-1 bg-primary/30 z-0" />

          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-6 relative">
            {processSteps.map((step, i) => <div key={step.id} data-index={i} className="relative flex md:flex-col gap-6 md:gap-0 group">
                {}
                {i !== processSteps.length - 1 && <div className="md:hidden absolute top-12 bottom-[-2rem] left-6 w-1 bg-primary/30 z-0" />}

                {}
                <div className="w-12 h-12 rounded-full bg-primary text-primary-foreground flex items-center justify-center font-default font-bold text-xl z-10 shrink-0 shadow-md md:mx-auto md:mb-8 relative transition-transform duration-300 group-hover:scale-110">
                  {step.id}
                </div>

                {}
                <Card className="flex-1 border-2 border-border shadow-none relative overflow-hidden hover:border-primary transition-colors rounded-none bg-card">
                  {}
                  <div className="absolute -right-6 -top-6 text-primary/5 group-hover:text-primary/10 transition-colors pointer-events-none">
                    <Octagon size={120} strokeWidth={1} />
                  </div>
                  
                  <CardHeader className="pb-4 relative z-10">
                    <CardTitle className="font-default text-xl flex items-center gap-2">
                      <Octagon className="w-5 h-5 text-primary fill-primary/20 shrink-0" />
                      <span>{step.title}</span>
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="relative z-10">
                    <p className="font-serif text-muted-foreground leading-relaxed">
                      {step.description}
                    </p>
                  </CardContent>
                </Card>
              </div>)}
          </div>
        </div>

        <div className="mt-16 md:mt-24 text-center w-full max-w-3xl mx-auto">
          <Button size="lg" className="w-full md:w-auto text-lg px-8 py-6 rounded-full font-default tracking-wide shadow-lg hover:shadow-xl transition-all" asChild>
            <Link to="/ContactPage">
              Schedule Your Free Inspection
              <ArrowRight className="ml-2 w-5 h-5" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}